function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o);
}
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t)
    return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i))
        return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return ("string" === r ? String : Number)(t); }
import { createTheme, outlinedInputClasses } from '@mui/material';
import '@fontsource/roboto';
import '@fontsource/open-sans';
import { defaultLightTheme } from '@deloitte/cc-ui-library';
export var theme = createTheme(_objectSpread(_objectSpread({}, defaultLightTheme), {}, {
    typography: {
        fontFamily: ['Roboto', 'Open Sans'].join(','),
        h1: {},
        h2: {},
        h3: {
            fontFamily: 'Open Sans',
            fontWeight: '400',
            fontSize: '48px',
            lineHeight: '145%'
        },
        h4: {
            fontFamily: 'Open Sans',
            fontWeight: '400',
            fontSize: '34px',
            lineHeight: '41.99px',
            letterSpacing: '.25px'
        },
        h5: {
            fontFamily: 'Open Sans',
            fontWeight: '400',
            fontSize: '24px',
            lineHeight: '32.02px'
        },
        h6: {
            fontFamily: 'Open Sans',
            fontWeight: '600',
            fontSize: '20px',
            lineHeight: '32px',
            letterSpacing: '.15px'
        },
        body1: {
            fontFamily: 'Open Sans',
            fontWeight: '400',
            fontSize: '16px',
            lineHeight: '24px',
            letterSpacing: '.15px'
        },
        subtitle1: {
            fontFamily: 'Open Sans',
            fontWeight: '400',
            fontSize: '16px',
            lineHeight: '28px',
            letterSpacing: '.15px'
        },
        subtitle2: {
            fontFamily: 'Open Sans',
            fontWeight: '600',
            fontSize: '14px',
            lineHeight: '24px',
            letterSpacing: '.17px'
        },
        button: {
            fontFamily: 'Open Sans',
            fontWeight: '600',
            fontSize: '13px',
            lineHeight: '22px',
            letterSpacing: '.46px'
        },
        body2: {
            fontFamily: 'Open Sans',
            fontSize: '14px',
            fontWeight: '400',
            lineHeight: '20px',
            letterSpacing: '0.17000000178813934px'
        },
        caption: {
            fontSize: '12px',
            fontFamily: 'Open Sans',
            fontWeight: '400',
            lineHeight: '19.92px'
        }
    },
    components: {
        // Name of the component
        MuiTab: {
            styleOverrides: {
            // Name of the slot
            }
        },
        MuiFormLabel: {
            styleOverrides: {
                root: {
                    '&.Mui-focused': {
                        color: '#26890D'
                    }
                }
            }
        },
        MuiInputBase: {
            styleOverrides: {
                root: {
                    height: '40px'
                }
            }
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: _defineProperty({}, "&.Mui-focused .".concat(outlinedInputClasses.notchedOutline), {
                    borderColor: '#26890D'
                })
            }
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    backgroundColor: '#0E336A',
                    color: '#fff',
                    // set the font color of the tooltip
                    fontFamily: 'Open Sans',
                    // set the font family of the tooltip
                    fontSize: '10px',
                    // set the font size of the tooltip
                    fontWeight: '600',
                    lineHeight: '14px'
                }
            }
        },
        MuiTypography: {
            defaultProps: {
                variantMapping: {
                // Map the new variant to render a <h1> by default
                }
            }
        },
        MuiButton: {
            styleOverrides: {
                sizeLarge: {
                    height: '42px'
                },
                sizeMedium: {
                    height: '36px'
                },
                sizeSmall: {
                    height: '30px'
                },
                contained: {
                    backgroundColor: '#26890D',
                    color: '#FFFFFF'
                },
                outlinedPrimary: {
                    borderColor: '#26890D',
                    color: '#26890D'
                },
                textPrimary: {
                    color: '#26890D'
                }
            }
        },
        MuiSwitch: {
            styleOverrides: {
                root: {
                    '& .MuiSwitch-switchBase.Mui-checked .MuiSwitch-thumb': {
                        backgroundColor: '#26890D'
                    },
                    '& .MuiSwitch-switchBase.Mui-checked': {
                        color: '#26890D',
                        '&:hover': {
                            backgroundColor: '#26890D33'
                        }
                    },
                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                        backgroundColor: '#26890D'
                    }
                },
                track: {
                    backgroundColor: '#00000099'
                }
            }
        }
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 1280,
            lg: 1700,
            xl: 1920
        }
    }
}));
